import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onBlur", "onChange", "onFocus", "value"];
import React, { useRef } from 'react';
import { CustomPropTypes, defineProps, useEventListener } from '@beef/react';
import { Input } from '@beef/ui-kit';
import PropTypes from 'prop-types';
var _NInput = function _NInput(_ref) {
  var className = _ref.className,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var firstSuggestRef = useRef(undefined);
  var handleChange = function handleChange() {
    firstSuggestRef.current = value;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onChange === null || onChange === void 0 || onChange.apply(void 0, args);
  };
  var handleBlur = function handleBlur() {
    return onBlur === null || onBlur === void 0 ? void 0 : onBlur(value);
  };
  useEventListener('blur', function (event) {
    return onBlur(value, event);
  }, firstSuggestRef);
  useEventListener('focus', function (event) {
    return onFocus(value, event);
  }, firstSuggestRef);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-NInput"
  }, /*#__PURE__*/React.createElement(Input, _extends({
    inputRef: firstSuggestRef,
    onBlur: handleBlur,
    onChange: handleChange,
    value: value
  }, props)));
};
_NInput.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  helpMessage: PropTypes.string,
  inputRef: CustomPropTypes.ref,
  keepErrorIndent: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string
} : {};
export var NInput = defineProps(undefined, {
  leftAside: null
})(_NInput);